
export default {
  name: 'BaseProfileProductCover',
  props: {
    product: {
      type: Object,
      default: null,
    },
    author: {
      type: Object,
      default: null,
    },
  },
  computed: {
    cover() {
      if (this.product?.cover) {
        return this.product?.cover
      } else if (this.author?.type === 'COMPANY') {
        return this.author?.company?.cover ? this.author.company.cover : null
      } else {
        return this.author?.profile?.cover ? this.author.profile.cover : null
      }
    },
    alt() {
      if (this.product?.shortDescription) {
        return this.product.shortDescription
      } else {
        if (this.product?.description) {
          const text = this.product.description
          if (text?.blocks?.length) {
            const preText = text.blocks.find(
              (block) => block.type === 'paragraph'
            )
            const sanitizeText = preText?.data?.text.replace(/<(.|\n)*?>/g, '')
            return sanitizeText
          }
        }
        return null
      }
    },
  },
  methods: {
    hexToRgbA(hex) {
      let c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return (
          'rgba(' +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
          ',0.3)'
        )
      }
      return hex
    },
  },
}
